import React from 'react';

/**
 * Container shell for any "list + filters + pagination" view in the
 * vendor portal. Keeps every page visually consistent.
 *
 * Children layout slots:
 *   - title (string|node)        → upper-left, list heading
 *   - actions (node)             → upper-right, buttons / filters row
 *   - search (node)              → second row, search input (optional)
 *   - children                   → the actual <table> or list contents
 *   - footer (node)              → pagination row
 */
export const DataTableShell = ({ title, actions, search, footer, children, testid = 'data-table-shell' }) => (
  <div
    className="bg-white border border-gray-200 rounded-xl shadow-[0_2px_8px_-2px_rgba(0,0,0,0.04)] overflow-hidden"
    data-testid={testid}
  >
    {(title || actions) && (
      <div className="px-6 py-4 border-b border-gray-100 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        {title && <h2 className="text-base font-semibold text-gray-900">{title}</h2>}
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    )}
    {search && <div className="px-6 pt-4">{search}</div>}
    <div className="overflow-x-auto vp-scroll">{children}</div>
    {footer && <div className="px-6 py-4 border-t border-gray-100">{footer}</div>}
  </div>
);

export default DataTableShell;
